export default "__VITE_ASSET__BbksztkB__"